import { Grid2 } from '@mui/material'
import { getExecStatusIcon, getExecStatusLabel } from '../../utils/JobUtils'
import i18n from '../../simple-react-i18n'
import { getFullDate } from '../../utils/DateUtil'
import ProgressBar from '../../components/progress/ProgressBar'
import React from 'react'
import PropTypes from 'prop-types'

const JobSyncStatus = ({
    jobSync,
    smallMode = false,
}) => {
    if (!jobSync) {
        return null
    }
    return (
        <Grid2 container justifyContent='flex-start' alignItems='center' columnSpacing={1}>
            <Grid2>{getExecStatusIcon(jobSync.exec, 30, getExecStatusLabel(jobSync.exec))}</Grid2>
            <Grid2 container>
                <Grid2 size={12} className={ smallMode ? 'font-size-x-small' : '' }>{ i18n.lastSyncJobOn } { getFullDate(jobSync.job.updateDate) }{ smallMode ? '' : ` ${ i18n.by } ${ jobSync.job.login }`}</Grid2>
                <Grid2 size={12} className={ smallMode ? 'font-size-x-small' : '' }>{ jobSync.updates && jobSync.updates !== 0 ? `${i18n.updateNumber} : ${ jobSync.updates }` : '' }{ jobSync.inserts && jobSync.inserts !== 0 ? `, ${i18n.insertNumber} : ${ jobSync.inserts }` : '' }</Grid2>
            </Grid2>
            {
                jobSync?.progress && !jobSync.exec?.statusCode && jobSync.exec?.statusCode !== 0 ? (
                    <Grid2 size='grow'><ProgressBar progress={jobSync?.progress} withMessage /></Grid2>
                ) : null
            }
        </Grid2>
    )
}

JobSyncStatus.propTypes = {
    jobSync: PropTypes.shape({}),
    smallMode: PropTypes.bool,
}

export default JobSyncStatus